module.exports = __webpack_public_path__ + "static/media/carousel3.368866f2.jpeg";